<template>
  <div class="cart-content">
    <!-- <div class="addr" v-if="JSON.stringify(logisticssList) != '{}'">
      <div class="left">
        <i class="qs-icon" />
      </div>
      <div class="right">
        <div class="name" v-if="logisticssList.traces[0].action == '1'">
          快递揽件中<i class="arrow" @click="goLogistics" />
        </div>
        <div class="name" v-if="logisticssList.traces[0].action == '2'">
          物流配送中<i class="arrow" @click="goLogistics" />
        </div>
        <div class="name" v-if="logisticssList.traces[0].action == '3'">
          商品已签收<i class="arrow" @click="goLogistics" />
        </div>
        <p class="msg">{{ logisticssList.traces[0].accept_station }}</p>
      </div>
    </div> -->
    <div class="addr">
      <div class="left">
        <i class="addr-icon" />
      </div>
      <div class="right">
        <div class="name">{{ orderDel.contacts }} {{ orderDel.phone }}</div>
        <p class="msg">
          {{ orderDel.province }}{{ orderDel.city }}{{ orderDel.area
          }}{{ orderDel.town }}{{ orderDel.addr }}
        </p>
      </div>
    </div>
    <div class="product-list">
      <ul>
        <li v-for="(item, index) in orderDel.productList" :key="index">
          <div class="flex">
            <div class="img-left">
              <img :src="item.image" alt="" />
            </div>
            <div class="other-right">
              <p class="name">{{ item.productName }}{{ item.skuName }}</p>
              <p class="num">数量：{{ item.count }}</p>
              <div class="integral">
                <span>积分</span>
                <b>{{ item.total }}积分</b>
                <span>
                  + <b>{{ item.totalPrice }}元</b></span
                >
              </div>
            </div>
          </div>
          <div class="combine" v-if="item.group && item.group.length">
            <p>组合商品明细</p>
            <div
              class="combine_item"
              v-for="(group, key) in item.group"
              :key="key"
            >
              <span>{{ group.name }}</span>
              <span>X{{ group.count }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="integral-total">
        <!-- <span>总积分：</span> -->
        <span>总计：</span>
        <b>{{ orderDel.totalIntegral }}积分</b>
        <span
          >+ <b>{{ orderDel.totalPrice }}元</b></span
        >
      </div>
      <div class="kefu" @click="kefuPhone">
        <i class="kefu-icon" />
        <span>联系客服</span>
      </div>
    </div>
    <div class="order-no">
      <div class="no">
        <span class="txt">订单编号：</span>
        <b>{{ orderDel._id }}</b>
        <span class="copy" @click="copy">复制</span>
      </div>
      <div class="date">
        <span class="txt">下单时间：</span>
        <b>{{ new Date(orderDel.createAt).toLocaleString() }}</b>
      </div>
      <div class="logistics_order" v-if="showCheckLogisticssBtn">
        <span class="txt">物流单号：</span>
        <ul class="logistics_order-list">
          <li class="logistics_order-li" v-for="(item,index) in logisticssInfo.info" :key="index">{{item.logistic_code}}</li>
        </ul>
        <button class="check_logistics" @click="openLogisticssHandle">查看物流</button>
      </div>
    </div>
    <!-- <span @click="goLogistics">查看物流</span> -->
    <!-- <div class="btn" v-if="showCheckLogisticssBtn">
      <b></b>
      <span @click="openLogisticssHandle">查看物流</span>
    </div> -->
    <ToBack />
    <Dialog
      :show="show"
      :text="tips"
      @closeDialog="closeDialog"
      @submitTips="submitTips"
    />
    <!-- <Logistics
      v-if="orderDel.state == 2"
      ref="log"
      :popupVisible="popupVisible"
      @closePopup="closePopup"
    /> -->
    <LogisticssPop
      :show.sync="showLogisticss"
      :logisticssInfo="logisticssInfo"
    />
  </div>
</template>

<script>
import http from "../common/http.js";
import ToBack from "./common/toback.vue";
import Dialog from "./common/dialog.vue";
// import Logistics from "./common/logisticss.vue";
import LogisticssPop from "./common/LogisticssPop.vue";
export default {
  components: {
    ToBack,
    Dialog,
    // Logistics,
    LogisticssPop,
  },
  data() {
    return {
      value: 1,
      show: false,
      tips: '<p style="margin:40px 0 20px 0">客服电话</p><p style="font-weight:bold">12098636546</p>',
      popupVisible: false,
      orderDel: JSON.parse(this.$route.query.data) || {},
      logisticssList: {},
      date: "",
      logisticssInfo: null, // 物流信息
      showLogisticss: false, // 是否显示物流弹窗
    };
  },
  computed: {
    // 是否显示查看物流按钮
    showCheckLogisticssBtn() {
      const logisticssInfo = this.logisticssInfo;
      if (!logisticssInfo) return;
      return !!logisticssInfo.info;
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.logisticssList = this.$refs.log.logisticssList[0] || {};
    // }, 500);
    this.getLogisticsInformation();
  },
  methods: {
    kefuPhone() {
      this.show = true;
    },
    closeDialog() {
      this.show = false;
    },
    submitTips() {
      this.show = false;
    },
    goLogistics() {
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
    },
    copy() {
      this.$copyText(this.orderDel._id).then(
        () => {
          this.$toast("复制成功");
        },
        () => {
          this.$toast("复制失败，请重新复制");
        }
      );
    },
    // 获取物流轨迹
    async getLogisticsInformation() {
      const { _id, province, city, area, town, addr } = this.orderDel;
      const res = await http.get(
        `/storage/public/logistic/orderNo?order_no=${_id}`
      );
      this.logisticssInfo = {
        address: `${province}${city}${area}${town}${addr}`,
        info: res.data,
      };
    },
    // 打开物流弹窗
    openLogisticssHandle() {
      this.showLogisticss = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-content {
  padding-top: 5px;
  padding-bottom: 60px;
  .addr {
    padding: 20px 15px;
    display: flex;
    // align-items: center;
    // justify-content: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px;
    margin-top: 10px;
    span {
      color: #333333;
      font-size: 16px;
    }
    i {
      display: block;
      width: 16px;
      height: 16px;
      background: url("../image/1@2x.png") no-repeat;
      background-size: contain;
    }
    .left {
      width: 20px;
      margin-right: 12px;
      i {
        display: block;
        width: 28px;
        height: 28px;
      }
      .qs-icon {
        background: url("../image/yky/物流.png") no-repeat;
        background-size: contain;
      }
      .addr-icon {
        background: url("../image/yky/地址.png") no-repeat;
        background-size: contain;
      }
    }
    .right {
      flex: 1;
      .name {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        .arrow {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url("../image/yky/箭头.png") no-repeat;
          background-size: contain;
        }
      }
      .msg {
        font-size: 12px;
        margin-top: 8px;
        color: #666666;
      }
    }
  }

  .product-list {
    margin-top: 10px;
    position: relative;
    z-index: 2;
    ul {
      background: #fff;
      border-radius: 12px 12px 0 0;
      padding: 0 15px;
      li {
        // display: flex;
        padding-top: 20px;
        .flex {
          display: flex;
          &:last-child {
            // border-bottom: 1px solid #f5f6fa;
            .other-right {
              border: none;
            }
          }
          .img-left {
            width: 84px;
            height: 84px;
            border-radius: 12px;
            background: #f5f6fa;
            margin-right: 12px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 12px;
            }
          }
          .other-right {
            flex: 1;
            padding-bottom: 22px;
            border-bottom: 1px solid #f5f6fa;
            .name {
              font-size: 14px;
            }
            .num {
              font-size: 12px;
              color: #666666;
              margin: 4px 0 15px;
            }
            .integral {
              span {
                font-size: 14px;
                margin-right: 4px;
              }
              b {
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
      }
      .combine {
        p {
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 18px;
        }
        .combine_item {
          margin-top: 4px;
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 18px;
          span:nth-of-type(1) {
            width: 70%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .integral-total {
      width: 100%;
      height: 52px;
      line-height: 52px;
      text-align: right;
      background: #fff;
      border-radius: 0 0 12px 12px;
      padding: 0 15px;
      box-shadow: 3px 3px 20px #e4e4ed;
      position: absolute;
      z-index: 2;
      span {
        font-size: 14px;
      }
      b {
        font-size: 16px;
        color: #d80a68;
        font-weight: bold;
      }
    }
  }

  .kefu {
    height: 52px;
    background: #fff;
    border-radius: 0 0 12px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    position: absolute;
    bottom: -110px;
    left: 0;
    right: 0;
    .kefu-icon {
      display: block;
      width: 28px;
      height: 28px;
      background: url("../image/yky/联系客服.svg") no-repeat;
      background-size: contain;
      margin-right: 5px;
    }
    span {
      font-size: 14px;
    }
  }

  .order-no {
    margin-top: 110px;
    background: #fff;
    border-radius: 12px;
    padding: 18px 16px;
    > div {
      .txt {
        color: #999999;
        font-size: 14px;
        margin-right: 10px;
      }
      b {
        font-size: 14px;
        font-weight: bold;
      }
      .copy {
        display: inline-block;
        width: 34px;
        height: 20px;
        background: #f5f6fa;
        line-height: 20px;
        text-align: center;
        border-radius: 10px;
        margin-left: 17px;
      }
    }
    .date {
      margin-top: 16px;
    }
  }

  .btn {
    width: 100%;
    height: 50px;
    border-top: 1px solid #e9e9e9;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    span {
      display: block;
      width: 98px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border: 1px solid #7db8dc;
      color: #7db8dc;
      border-radius: 20px;
    }
  }

  .logistics_order {
    display: flex;
    margin-top: 16px;
    .logistics_order-list {
      line-height: 20px;
      .logistics_order-li {
        width: 174px;
        white-space: nowrap;
        overflow:hidden;
        font-weight: bold;
        text-overflow: ellipsis;
        & + .logistics_order-li {
          margin-top: 8px;
        }
      }
    }
    .check_logistics {
      display: inline-block;
      background: #f5f6fa;
      line-height: 20px;
      text-align: center;
      border-radius: 10px;
      margin-left: 17px;
      border: none;
      outline: none;
      height: 20px;
    }
  }
}
</style>
